enum EffectTypes {
  Assign = 'ASSIGN',
}

export default EffectTypes;
export type VerifyEffectTypes = Utils.VerifyExtends<Model.Enum.EffectTypes, Utils.ValueOf<typeof EffectTypes>>;
